module.exports = __webpack_public_path__ + "img/rule.fd398e5e.png";